export function getPendingHSDescription(axiosPrivate: any, params: any) {
  const id = params.id
  return axiosPrivate.get(`/master-data/hs-description/review/${id}`)
}

export function submitHSDescriptionReview(axiosPrivate: any, id: any, data: any) {
  return axiosPrivate.post(`/master-data/hs-description/review/${id}`, data)
}
